const price = [
    {
        "_id": 0,
        "name": "Any",
        "array": []
    },
    {
        "_id": 1,
        "name": "₦0 to ₦50,000",
        "array": [0, 50000]
    },
    {
        "_id": 2,
        "name": "₦50,001 to ₦100,000",
        "array": [50001, 100000]
    },
    {
        "_id": 3,
        "name": "₦100,001 to ₦150,000",
        "array": [100001, 150000]
    },
    {
        "_id": 4,
        "name": "₦150,001 to ₦200,000",
        "array": [150001, 200000]
    },
    {
        "_id": 5,
        "name": "more than ₦200000",
        "array": [200001, 10000000]
    },
]




const continents = [
    {"_id": 1, "name":"Cloud Infrastruture"},
    {"_id": 2, "name":"Project Management"},
    {"_id": 3, "name":"Security"},
    {"_id": 4, "name":"Business Analysis"},
    {"_id": 5, "name":"Networking"},
    {"_id": 6, "name":"IT Governance"},
    {"_id": 7, "name":"Software Development"}
]

export {price, continents};